import { Controller } from "@hotwired/stimulus"

export default class CheckboxGroupController extends Controller {
  static targets = ["parent", "child"]

  emitChangedEvent(event) {
    this.dispatch(event.target.checked ? "checked" : "unchecked", {
      target: event.target,
    })
  }

  selectParent() {
    this.parentTarget.checked = true
  }

  deselectChildren() {
    this.childTargets.forEach((checkbox) => {
      checkbox.checked = false
    })
  }
}
